/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MarcatoreListByCorpoDto } from '../../models/marcatore-list-by-corpo-dto';

export interface ApiMarcatoreMarcatoreListPost$Params {
    /**
     * Oggetto contenente i tipi dei marcatori da caricare
     */
    body: MarcatoreListByCorpoDto;
}

export function apiMarcatoreMarcatoreListPost(
    http: HttpClient,
    rootUrl: string,
    params: ApiMarcatoreMarcatoreListPost$Params,
    context?: HttpContext,
): Observable<StrictHttpResponse<number>> {
    const rb = new RequestBuilder(rootUrl, apiMarcatoreMarcatoreListPost.PATH, 'post');
    if (params) {
        rb.body(params.body, 'application/json');
    }

    return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return (r as HttpResponse<any>).clone({
                body: parseFloat(String((r as HttpResponse<any>).body)),
            }) as StrictHttpResponse<number>;
        }),
    );
}

apiMarcatoreMarcatoreListPost.PATH = '/api/marcatore/marcatore-list';
